import { ExtendedAxiosResponse, apiClient } from 'helpers/apiClient';

export const api = {
  cancelClaim: (
    url: string,
    invoiceNumber: string,
    claimId: number,
    serviceId?: number
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/claimStep1/cancelClaim`,
      {},
      {
        params: {
          invoicenumber: invoiceNumber,
          claimid: claimId,
          serviceid: serviceId,
        },
      }
    ),
  getData: (
    url: string,
    timeout: number,
    invoiceNumber: string,
    claimId?: number,
    serviceId?: number | null,
    productNo?: string,
    posNext?: number | null,
    pageSize?: number
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/claimStep1/getData`, {
      params: {
        invoicenumber: invoiceNumber,
        claimid: claimId,
        serviceid: serviceId,
        productNo: productNo,
        posNext: posNext,
        pageSize: pageSize,
      },
      timeout: timeout,
    }),
  lazyload: (
    url: string,
    invoiceNumber: string,
    claimId?: number,
    serviceId?: number,
    productNo?: string,
    posNext?: number | null,
    pageSize?: number
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/claimStep1/lazyload`, {
      params: {
        invoicenumber: invoiceNumber,
        claimid: claimId,
        serviceid: serviceId,
        productNo: productNo,
        posNext: posNext,
        pageSize: pageSize,
      },
    }),
  saveClaimStep1: (
    url: string,
    invoiceNumber: string,
    claimId: number,
    serviceId?: number,
    createDate?: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/claimStep1/saveClaimStep1`,
      {},
      {
        params: {
          invoicenumber: invoiceNumber,
          claimid: claimId,
          serviceid: serviceId,
          createDate: createDate,
        },
      }
    ),
  step1changeInvoice: (
    url: string,
    invoiceNumber: string,
    invoiceNumberNew: string,
    claimId: number
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/claimStep1/step1changeInvoice`,
      {},
      {
        params: {
          invoicenumber: invoiceNumber,
          invoicenumbernew: invoiceNumberNew,
          claimid: claimId,
        },
      }
    ),
};
